// extracted by mini-css-extract-plugin
module.exports = {"socialNetworks":"SocialNetworks_socialNetworks__1qKxq","socialNetworks__link":"SocialNetworks_socialNetworks__link__BZB30"};